import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum ProfileStatusEnum {
    Available = 1 as any,
    Busy = 2 as any,
    DoNotDisturb = 3 as any,
    BeRightBack = 4 as any,
    Away = 5 as any,
    Offline = 6 as any
}

export enum ProfileActivityStatusEnum {
    InACall = 7,
    InActive = 8,
    Logout = 9,
    ResetActivity = 0
}

export enum ProfileColorEnum {
    Blue = 1,
    Crimson = 2,
    Teal = 3,
    Purple = 4,
    Magenta = 5
}

export class ProfileStatusEnumClass extends EnumWithDescription<ProfileStatusEnum> {
    public readonly enum = ProfileStatusEnum;
    public readonly enumName: string = "ProfileStatusEnum";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<ProfileStatusEnum>> = new Map([
        [
            "available",
            {
                value: ProfileStatusEnum.Available,
                name: "Available"
            }
        ],
        [
            "busy",
            {
                value: ProfileStatusEnum.Busy,
                name: "Busy"
            }
        ],
        [
            "dnd",
            {
                value: ProfileStatusEnum.DoNotDisturb,
                name: "Do Not Disturb"
            }
        ],
        [
            "brb",
            {
                value: ProfileStatusEnum.BeRightBack,
                name: "Be Right Back"
            }
        ],
        [
            "away",
            {
                value: ProfileStatusEnum.Away,
                name: "Away"
            }
        ],
        [
            "offline",
            {
                value: ProfileStatusEnum.Offline,
                name: "Offline"
            }
        ]
    ]);
}

export const ProfileStatus = new ProfileStatusEnumClass();
